import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { withActionsExecutor, ActionsExecutorPropsType } from "components/actions";
import { Button, Grid, Typography } from 'components/controls/widget';
import PageContent from "common/web/PageContent";
import Loading from "common/components/controls/Loading";
import Error from "common/components/controls/Error";
import * as moment from "moment";
import { LoadingInfo } from "common/components/controls/Loading";
import { Payment, PaymentState, apiGetPayments } from "common/api/Payments";
import { UIContextQuery, apiPutContext } from "common/api/UIContext";
import UIContextService, { UIContextData } from "common/services/UIContextService";
import { DisplayLicence, apiGetLicences } from "common/api/members/licencess";
import EditacePlatby from "./EditacePlatby";
import SeznamPlateb from "./SeznamPlateb";
import SeznamPrispevku from "./SeznamPrispevku";
import { PrispItem } from "./SeznamPrispevkuItem";
import PlatebniUdaje from "./PlatebniUdaje";


interface PrispevkyProps {
    idtClena: number;
}

interface State {
    showDialog: boolean;
    showPaymentDialog: boolean;
    rok?: number;
    payments: Payment[];
    payment?: Payment;
    prispAktualni: DisplayLicence[];
    prispDalsiRok: DisplayLicence[];
    loading: LoadingInfo;
    prispAktualniLoading: LoadingInfo;
    prispDalsiRokLoading: LoadingInfo;
    platbyLoading: LoadingInfo;
    uiContextData: UIContextData;
}

type PropsType = PrispevkyProps & State & ActionsExecutorPropsType & WithStyles<typeof styles>;

const initialState: State = {
    showDialog: false,
    showPaymentDialog: false,
    payments: [],
    platbyLoading: {},
    prispAktualni: [],
    prispDalsiRok: [],
    loading: {},
    prispAktualniLoading: {},
    prispDalsiRokLoading: {},
    uiContextData: {},
}

class Prispevky extends React.PureComponent<PropsType> {

    aktualniRok: number;
    dalsiRok?: number;
    jenPolovicniPlatby: boolean;

    constructor(props: PropsType) {
        super(props);
        const currentDate = moment();
        this.aktualniRok = currentDate.year();
        this.jenPolovicniPlatby = currentDate.month() >= 6;
        if (currentDate.month() >= 10) { // month is zaro based (0 to 11)
            this.dalsiRok = this.aktualniRok + 1;
        }
    }

    load = () => {
        const { executeAction, updateState, idtClena } = this.props;
        const action = apiPutContext()
            .onSuccess(d => {

                const uiContext = UIContextService.getContext(d);

                updateState({ loading: { loading: false }, uiContextData: uiContext });

                this.loadPrisp();
                this.loadPlatby();
            })
            .onError(e => {
                updateState({ loading: { loading: false, hasError: true, error: e.message } });
            });

        const contextQry = UIContextService.createContextQuery('member', { id: idtClena });

        executeAction(action, { loading: { loading: true, hasError: false } }, contextQry);
    }

    loadPrisp = () => {
        if (this.showPrisp()) {
            this.loadPrispInternal(true);
            if (this.dalsiRok !== undefined) {
                this.loadPrispInternal(false, moment().year(this.dalsiRok).month(0).date(1).toDate());
            }
        }
    }


    loadPrispInternal = (aktualni: boolean, forDate?: Date) => {
        const { executeAction, updateState, idtClena } = this.props;
        const prispType = aktualni ? 'Aktualni' : 'DalsiRok';

        const action = apiGetLicences(idtClena, forDate)
            .onSuccess(d => {
                updateState({ [`prisp${prispType}Loading`]: { loading: false }, [`prisp${prispType}`]: d });
            })
            .onError(e => {
                const errMessage = e.message;
                updateState({ [`prisp${prispType}Loading`]: { loading: false, hasError: true, error: errMessage } });
            });

        executeAction(action, { [`prisp${prispType}Loading`]: { loading: true, hasError: false }, [`prisp${prispType}`]: [] });
    }

    loadPlatby = () => {
        if (this.showPlatby()) {
            const { executeAction, updateState, idtClena } = this.props;

            const action = apiGetPayments(idtClena)
                .onSuccess(d => {
                    updateState({ platbyLoading: { loading: false }, payments: d });
                })
                .onError(e => {
                    const errMessage = e.message;
                    updateState({ platbyLoading: { loading: false, hasError: true, error: errMessage } });
                });

            executeAction(action, { platbyLoading: { loading: true, hasError: false }, payments: [], payment: undefined });
        }
    }

    onClose = (p?: Payment) => {
        this.props.updateState({ showDialog: false, rok: undefined });

        if (p !== undefined && p.state === PaymentState.Sended) {
            this.loadPlatby();
            this.loadPrisp();
            this.showPaymentInfo(p);
        }
    }

    showPaymentInfo = (p: Payment) => {
        this.props.updateState({ showPaymentDialog: true, payment: p });
    }

    closePaymentInfo = () => {
        this.props.updateState({ showPaymentDialog: false, payment: undefined });
    }

    showPrisp = () => {
        const { uiContextData } = this.props;
        return uiContextData.member && uiContextData.member.hasAccess;
    }

    showPlatby = () => {
        const { uiContextData } = this.props;
        return uiContextData.member && uiContextData.member.hasAccess && uiContextData.member.clubId === undefined;
    }


    componentDidMount() {
        this.load();
    }

    render() {
        const { idtClena, showDialog, showPaymentDialog, rok, payment, payments, platbyLoading, updateState, classes } = this.props;
        const { prispAktualni, loading, prispAktualniLoading, prispDalsiRok, prispDalsiRokLoading } = this.props;

        const prispItems: PrispItem[] = [{ rok: this.aktualniRok, prispevky: prispAktualni, loadingInfo: prispAktualniLoading }];
        if (this.dalsiRok !== undefined) {
            prispItems.push({ rok: this.dalsiRok, prispevky: prispDalsiRok, loadingInfo: prispDalsiRokLoading });
        }

        return <PageContent titles={['Platby a příspěvky']}>
            {loading.loading
                ? <Loading loading={loading.loading} color="primary" />
                : loading.hasError
                    ? <Error>{loading.error}</Error>
                    : <Grid container direction="column" spacing={16}>
                        {this.showPrisp() && <Grid item>
                            <Typography variant="h6" color="primary">{'Příspěvky'}</Typography>
                        </Grid>}
                        {this.showPrisp() && <Grid item>
                            <SeznamPrispevku items={prispItems} />
                        </Grid>}

                        {this.showPlatby() && <Grid item>
                            <hr className={classes.spacer} />
                            <Typography variant="h6" color="primary">{'Platby'}</Typography>
                        </Grid>}

                        {this.showPlatby() && <Grid item>
                            <Grid container direction="row" justify="space-between">
                                <Button color="primary" variant="contained" onClick={() => updateState({ showDialog: true, rok: this.aktualniRok })}>{`Editace platby příspěvků ${this.aktualniRok}`}</Button>
                                {this.dalsiRok && <Button color="primary" variant="contained" onClick={() => updateState({ showDialog: true, rok: this.dalsiRok })}>{`Editace platby příspěvků ${this.dalsiRok}`}</Button>}
                            </Grid>
                        </Grid>}
                        {this.showPlatby() && <Grid item>
                            <SeznamPlateb idtClena={idtClena} showPaymentInfo={this.showPaymentInfo} paymentInfoIsVisible={showPaymentDialog} payments={payments} loadingInfo={platbyLoading} />
                        </Grid>}
                    </Grid>
            }
            <PlatebniUdaje show={showPaymentDialog} payment={payment} close={this.closePaymentInfo} />
            <EditacePlatby idtClena={idtClena} rok={this.aktualniRok} show={showDialog && rok === this.aktualniRok} onClose={this.onClose} jenPolovicniPlatby={this.jenPolovicniPlatby} />
            {this.dalsiRok && <EditacePlatby idtClena={idtClena} rok={this.dalsiRok} show={showDialog && rok === this.dalsiRok} onClose={this.onClose} jenPolovicniPlatby={false} />}
        </PageContent>
    }
}


const styles = (theme: Theme) => createStyles({
    content: {
        padding: theme.spacing.unit,
    },
    spacer: {
        width: '100%',
        borderStyle: 'hidden',
        height: 2 * theme.spacing.unit,
    },
});

export default withActionsExecutor<PrispevkyProps, State>(initialState, withStyles(styles)(Prispevky));

